var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AbSection,{staticClass:"cn-category-banner-small-group-section",attrs:{"spacing":_vm.spacing}},[_c(_setup.AbContainer,[_c('div',{staticClass:"cn-category-banner-small-group-section__content"},_vm._l((_vm.items),function(item,i){return _c(_setup.CategoryBannerSmall,{key:i,attrs:{"data":{
          ...item,
          position: _setup.position(i),
        }}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }